import { render, staticRenderFns } from "./RegionTeamMembers.vue?vue&type=template&id=460e625b&scoped=true"
import script from "./RegionTeamMembers.vue?vue&type=script&lang=js"
export * from "./RegionTeamMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e625b",
  null
  
)

export default component.exports